/**
 * What the bottom bar is doing, for chrome that lives outside it (job #48,
 * Tom 2026-09-24: one way back, and nothing floating over the controls).
 *
 *   barsMounted  — how many bottom bars are on screen. The update pill moves
 *                  into the mode button's row while one is (PwaUpdatePrompt),
 *                  so it can never sit over a page's header controls.
 *   barShowsBack — the player's bar is showing its back arrow. The staff
 *                  dashboard pill (App.vue) steps aside while it is, so a
 *                  screen never offers two ways back at once.
 *
 * A count rather than a flag: going from the player to /talk mounts the next
 * bar before the old one unmounts.
 */
import { computed, ref } from 'vue'

const mounted = ref(0)

export const barsMounted = computed(() => mounted.value > 0)
export const barShowsBack = ref(false)

export function barMounted(): void { mounted.value += 1 }
export function barUnmounted(): void { mounted.value = Math.max(0, mounted.value - 1) }
